export default "__VITE_ASSET__$XGUn$jR__"